module.exports = __webpack_public_path__ + "static/media/rebirth_sample_13.33b63d69.jpg";